import { Component, OnInit } from '@angular/core';
import { NgForm, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BackendService } from '../../shared/backend.service';
//import { NotificationService } from '../../notification/notification.service';
import { AuthService } from '../../shared/auth.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { saveAs as importSaveAs} from 'file-saver';
import * as XLSX from 'xlsx';
import CONFIG from 'src/app/config';
import { DatePipe } from '@angular/common';
import { AlertmessageService } from 'src/app/shared/alertmessage.service';
import { Router } from '@angular/router';
import { OrderByService } from 'src/app/shared/orderby.service';
import { NotificationService } from 'src/app/notification.service';
//import { NotificationService } from 'src/app/notification.service';


@Component({
  selector: 'app-file-transfer',
  templateUrl: './file-transfer.component.html',
  styleUrls: ['./file-transfer.component.scss'],
  providers:[DatePipe,OrderByService,AlertmessageService]
})
export class FileTransferComponent implements OnInit {
  fileTransfer: FormGroup;
  DateFilter: FormGroup;
  enddate: any;
  paymentdate: any;
  item:any;
  submittedYear:any;

  files:FileList;
  filestring:any;
  fileByte:any;
  fileName:string;
  bankId: any;
  branchcodes: any;
  bankbranchids: any;
  branchfiltercodes: any;
  bankcodevalue: any;
  branchcodevalue: any;
  submissionrecords: any;
  submissionrecordsfilter:any;
  FileName:string;
  active: string = '';
  arrayBuffer:any;
file:File;
localUrl: any[];
fileInput:string="Choose File...";
sheet1Data: any;
sheet2Data: any;
BankId:any;
branchessss: Array<string>;
accounttype: any;
  currency: any;
  currencies: any;
  items: any;
  dasubmission:any;
  spinner:boolean=true;
  years: number[] = [];

submission: boolean = false;
  constructor(
    public _formBuilder: FormBuilder,
    public backendService: BackendService,
    public authService: AuthService,
    private _http: HttpClient,
    public _datepipe:DatePipe,
    public notificationService: NotificationService,
    public alert:AlertmessageService,
    public router:Router,
    public orderByService: OrderByService,
  ) 
  {
    this.setForm();
   }

  ngOnInit() 
  {
    this.spinner=true;
    this.getbankIdDropdown();
    if(this.authService.LoginType!="Admin")
    {
      this.bankcodevalue=this.authService.TaskNumber;
      this.getsubmissionforclient();
    }
    else
    {
      // this.bankcodevalue=this.BankId;
      // this.getsubmissionforclient();
    }
    
    this.DateFilter = this._formBuilder.group({
      'enddate': [''],
      'paymentdate': ['']   

    });
    this.submittedYear = new Date().getFullYear() - 1;
    this.enddate = new FormControl(new Date());
    this.paymentdate = new FormControl(new Date());

    const currentYear = new Date().getFullYear();
    for (let year = 2017; year <= currentYear; year++) {
      this.years.push(year);
    }
  }

  getbankIdDropdown() {
    //this.bankcodevalue = this.dataEntry.controls['BankCode'].value;
    this.backendService.getData(`${CONFIG.getbankIdDropdownApiUrlBase}`)
      .subscribe(response => {
        this.bankId = response['bankid'];
        this.branchcodes = response['branchcodelist'];
        this.bankbranchids = response['bankbranchids'];
        this.submissionrecords = response['submissionrecords'];
      //  console.log(this.submissionrecords );

      });
      this.backendService.getData(`${CONFIG.getdataentryDropdownsApiUrlBase}`)
      .subscribe(response => {
        this.accounttype = response['accounttype'];
        this.currency = response['currency'];
        this.currencies = response['currencies'];
        if(this.authService.LoginType!="Admin")
        {
         // console.log(this.currencies);
          for(let i=0;i<this.currencies.length;i++)
          this.currencies[i].totalamount=0;
         // console.log(this.currencies);
          this.submissionrecordsfilter= this.currencies;
          //this.submissionrecordsfilter.totalamount=0.00;
          this.submission = true;
          //if(this.submissionrecords.>0)
          //this.submissionrecordsfilter = this.submissionrecords.filter(x => x.bankcode == this.authService.TaskNumber);
        }
       // console.log(this.accounttype, this.currency, this.currencies);
      });
     
     
    }
    getsubmissionforclient()
    {
      this.backendService.getData(`${CONFIG.getAccountInfoGridApiUrlBase}/${this.bankcodevalue}`)
      .subscribe(response => {
        this.formateData(response['accountifo']);
        this.items = response['accountifo'];
        this.dasubmission=response['dasubmissions'];
       // console.log(this.dasubmission);
        //this.afterEditData=this.items;
       // console.log(this.items);
      })
    }
    formateData(data)
  {
    // data.map((d: { lasttransdate: string; }) => {
    //   d.lasttransdate = this._datepipe.transform(d.lasttransdate.toString(), "MM/dd/yyyy");

    // });
  
      // if (data) {
      //   data.forEach((d: { LastTransDate: string; }) => {
      //     d.LastTransDate = this._datepipe.transform(d.LastTransDate.toString(), "MM/dd/yyyy");
      //     console.log("Error in file Transer")
      //   });
      // }
      if (data) {
        data.forEach((d: { LastTransDate: string; }) => {
          if (d.LastTransDate) {
            d.LastTransDate = this._datepipe.transform(d.LastTransDate.toString(), "MM/dd/yyyy");
          }
        });
      }
  }
    filterBranchCode(value)
    {
      let myArray = [];
      this.BankId=value;
     // console.log(value);
      this.branchfiltercodes = this.bankbranchids.filter(x => x.bankCode == this.BankId);
      for (var i = 0; i < this.branchfiltercodes.length; i++) {
        this.branchessss = this.branchfiltercodes[i]['branchCode'];
        myArray.push(this.branchessss);
      //  console.log(myArray);
  
      }
      this.branchcodes = myArray;
      this.submission = true;
      //this.submissionrecords = this.submissionrecords;
      this.submissionrecordsfilter = this.submissionrecords.filter(x => x.bankcode == this.BankId);
      
      //console.log(this.submissionrecordsfilter,this.BankId);
      this.bankcodevalue=this.BankId;
      //console.log(this.bankcodevalue);
      if(this.bankcodevalue!=null)
        this.getsubmissionforclient();
      //this.getAccountInfoGrid();
    }
    editDASubmission(item)
  {
    item.submitted=true;
    //item.status=false;
    //console.log(item);
  }
  valueOfTotalAmount(value,item)
  {
    item.totalamount=value;
    //console.log(value,item);
  }
  valueOfPaymentMethod(value,item)
  {
    item.paymentmethod=value;
    //console.log(value,item);
  }
  valueOfCheckNo(value,item)
  {
    item.referenceno=value;
   // console.log(value,item);
  }
  UpdateDASubmission(item)
  {
    item.submitted=false;
    //console.log(item);
    if(this.authService.LoginType=="Admin")
    {
        this.backendService.putData(item,`${CONFIG.updateDASubmissionsApiUrlBase}`)
                        .subscribe(response=>{
                          //console.log(response);
                          if(response['result'])
                        {
                          this.notificationService.showNotification({ type: 'success', message:response['msg']});
                        }
                          else
                        {
                          this.notificationService.showNotification({ type: 'error', message:response['msg']});
                        }
                      });
    }
    else
    {
      item.bankcode=this.authService.TaskNumber;
      this.backendService.putData(item,`${CONFIG.updateDASubmissionsApiUrlBase}`)
                        .subscribe(response=>{
                          //console.log(response);
                          if(response['result'])
                        {
                          this.notificationService.showNotification({ type: 'success', message:response['msg']});
                        }
                          else
                        {
                          this.notificationService.showNotification({ type: 'error', message:response['msg']});
                        }
                      });
    }

  }
  makeActive(item) 
  {
    
     this.active === item ? '' : item;
  }
  downloadFile1()
    {
      let link = document.createElement("a");
      link.download = "DormantAccountsImport";
      link.href = "assets/img/DormantAccountsImport.xlsx";
      link.click();
    }
    downloadFile()
    {
      this.FileName="DormantAccountsImport.xlsx";
      this.backendService.downloadFile(`${CONFIG.downloadFile}`,this.FileName).
      subscribe(blob=>{
        importSaveAs(blob,this.FileName)

      }
        );
     // console.log("Download File");
    }

  onSubmit(Data)
  {
    this.spinner=false;
    if(this.authService.LoginType=="Admin")
    {
    Data.BankId=this.BankId;
    //Data.submittedyear=this.submittedYear;
    if(Data.BankId==undefined)
    {
      this.alert.openConfirmationDialog("Please select Bank ID.");
    }
    else if(this.files==undefined)
    {
      this.alert.openConfirmationDialog("You must choose the File.");
    }
    else if(Data.FirstName=="" || Data.LastName=="" || Data.Position==""||Data.EmailAddress==""||Data.Comments==""||Data.Phone=="")
    {
      this.alert.openConfirmationDialog("You must fill the fields.");
    }
    else
    {
    Data.inputfile=this.files[0].name;
    //console.log(this.paymentdate.value);
    Data.ExcelData=this.sheet1Data;
    Data.fileByte=this.fileByte;
    Data.fileName=this.files[0].name;
    Data.paymentdate=this._datepipe.transform(this.paymentdate.value,"MM/dd/yyyy");
    //console.log(Data);
    this.backendService.postData(Data,`${CONFIG.filetransfersaveApiUrlBase}/${this.BankId}`)
                      .subscribe(response=>{
                        //console.log(response);
                      if(response['result'])
                      {
                        this.alert.openConfirmationDialogShot(response['msg']);
                        this.spinner=true;
                        this.router.navigate(['/dashboard']);
                      }
                      else
                      {
                        this.alert.openConfirmationDialogLong(response['msg']);
                      }
                      });
  }
}
else
{
  Data.BankId=this.authService.TaskNumber;
    //Data.submittedyear=this.submittedYear;
   
    if(this.files==undefined)
    {
      this.alert.openConfirmationDialog("You must choose the File.");
    }
    else if(Data.FirstName=="" || Data.LastName=="" || Data.Position==""||Data.EmailAddress==""||Data.Comments==""||Data.Phone=="")
    {
      this.alert.openConfirmationDialog("You must fill the fields.");
    }
    else
    {
    Data.inputfile=this.files[0].name;
  //  console.log(this.paymentdate.value);
    Data.ExcelData=this.sheet1Data;
    Data.fileByte=this.fileByte;
    Data.fileName=this.files[0].name;
    Data.paymentdate=this._datepipe.transform(this.paymentdate.value,"MM/dd/yyyy");
   // console.log(Data);
    this.backendService.postData(Data,`${CONFIG.filetransfersaveApiUrlBase}/${this.authService.TaskNumber}`)
                      .subscribe(response=>{
                        //console.log(response);
                        if(response['result'])
                        {
                          this.alert.openConfirmationDialogShot(response['msg']);
                          this.router.navigate(['/dashboard']);
                        }
                        else
                        {
                          this.alert.openConfirmationDialogLong(response['msg']);
                        }
                      });
  }
}


  }
  getFileDetails(event) {
    this.files = event.target.files;
    //console.log(this.files);
   // console.log(event, this.files[0].size);
    //console.log(this.files[0].type);
    
      //  console.log("Test1");
        var reader = new FileReader();
        reader.onload = this._handleReaderLoadded.bind(this);
       // console.log(reader.onload)
        reader.readAsBinaryString(this.files[0]);
        event.fileName = this.files[0].name;
        event.fileByte = this.filestring;
     
   

  }
  _handleReaderLoadded(event) {
    var binaryString = event.target.result;
    this.filestring = btoa(binaryString); //Converting Binary String Data
    var reader = new FileReader();
    reader.readAsBinaryString(this.files[0]);
    event.fileName = this.files[0].name;
    event.fileByte = this.filestring;
   // console.log(event.fileByte);
    this.fileByte=event.fileByte;
  }

  onFileChange(event) {
    this.file = event.target.files[0];
    this.files= event.target.files;
   // console.log("Test", this.file);
    if (this.files[0].type == "application/vnd.ms-excel" || this.files[0].type =="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
     {
    this.Upload();
    this.getFileDetails(event);
    //console.log(event);
    if (this.files[0].name.length < 30){
      var str = this.files[0].name;
      this.fileInput = str.slice(0, 30);
    } else {
      var str = this.files[0].name;
      this.fileInput = str.slice(0, 25) + '...' + str.slice(-4);
    }
  }
  else
  {
      this.alert.openConfirmationDialog(" Please select a file of type Excel only ");
  }

}
  Upload() {
    //console.log("Test");
    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet1 = workbook.Sheets[first_sheet_name];
      var Activity = workbook.SheetNames[1];
      var worksheet2 = workbook.Sheets[Activity];
      //console.log(XLSX.utils.sheet_to_json(worksheet1, { raw: true }));
     // console.log(XLSX.utils.sheet_to_json(worksheet2, { raw: true }));
      this.sheet2Data = XLSX.utils.sheet_to_json(worksheet2, { raw: true });
      this.sheet1Data = XLSX.utils.sheet_to_json(worksheet1, { raw: true });
     // console.log(this.sheet1Data, this.sheet2Data);
      // this.uploadFiles();
      // this._handleReaderLoadded(event)

    }
    fileReader.readAsArrayBuffer(this.file);
  }



  // onFileChange(event)
  // {
  //   this.localUrl = event.target.result;

  //   const { read, write, utils } = XLSX;
  //   //const wb: XLSX.WorkBook = XLSX.read(event);
    
  //   this.file = event.target.files;
   
  //  // console.log(event, this.files[0].type);
  //   console.log(event, this.localUrl,  event.target.files);

  //  // let wb: XLSX.IWorkBook = XLSX.read(event);

  //   // You can change the file path in the assets folder
  //   let url = "/assets/template.xlsx";
  //   let req = new XMLHttpRequest();

  //   //let fileReader = new FileReader();
  //   this.arrayBuffer = "arraybuffer";
  //   req.open("GET", url, true);
  //   req.responseType =  this.arrayBuffer;
    
  //   req.onload =  (e) => {
  //       let data = new Uint8Array(req.response);
  //       let workbook = XLSX.read(data, {type: "array"});
  //       const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});

  //       console.log(workbook, excelBuffer);
  //       var first_sheet_name = workbook.SheetNames[0];
  //       workbook.Sheets[first_sheet_name];
  //       console.log(first_sheet_name, workbook.Sheets[first_sheet_name]);
  //       var worksheet = workbook.Sheets[first_sheet_name];
  //       console.log(XLSX.utils.sheet_to_json(worksheet,{raw:true}));
  //       // TO export the excel file
  //      // this.saveAsExcelFile(excelBuffer, 'X');
  //   };
  //   req.send();




  //   // let fileReader = new FileReader();
  //   // fileReader.onload = (e) => {
  //   //     this.arrayBuffer = fileReader.result;
  //   //     var data = new Uint8Array(this.arrayBuffer);
  //   //     var arr = new Array();
  //   //     for(var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
  //   //     var bstr = arr.join("");
  //   //     var workbook = XLSX.read(bstr, {type:"binary"});
  //   //     var first_sheet_name = workbook.SheetNames[0];
  //   //     var worksheet = workbook.Sheets[first_sheet_name];
  //   //     console.log(XLSX.utils.sheet_to_json(worksheet,{raw:true}));
  //   // }
  //   // fileReader.readAsArrayBuffer(this.file);

  //   // console.log( fileReader.readAsArrayBuffer(this.file));




  //   // this.files=event.target.files;
  //   // console.log(event,this.files[0].type);
  //   // var reader=new FileReader();
  //   // reader.onload=this._handleReaderLoadded.bind(this);
  //   // reader.readAsBinaryString(this.files[0]);
  //   // //this.fileByte.push(this.filestring);
  //   // console.log(this.files);

  //   // console.log(reader.onload);
  //   // console.log(reader.readAsBinaryString(this.files[0]));
    

   
  // }
  // _handleReaderLoadded(readerEvt)
  // {
  //   var binaryString=readerEvt.target.result;
  //   this.filestring=btoa(binaryString); //Converting Binary String Data
  //   console.log(this.filestring); 
    
  //   console.log(binaryString);
  //   //console.log(this.files);

  // }

  setForm() {
    this.fileTransfer = this._formBuilder.group({ 
      'BankId':[''] , 
      'inputfile':[''],
      'submittedyear':[''],
      'FirstName': [''],    
      'MiddleName': [''],     
      'LastName': [''],
      'Position': [''],    
      'Email': [''],     
      'PhoneNumber': [''],
      'Comments': ['']
    });
  }
}
